import { render, staticRenderFns } from "./myC2c.vue?vue&type=template&id=47cfc758&scoped=true&"
import script from "./myC2c.vue?vue&type=script&lang=js&"
export * from "./myC2c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cfc758",
  null
  
)

export default component.exports